/**
 * List of all countries with their codes, names (in French), and phone prefixes
 * Sorted alphabetically by French name
 */
export const countries = [
    { code: 'AF', name: 'Afghanistan', phonePrefix: '+93', flag: '🇦🇫' },
    { code: 'ZA', name: 'Afrique du Sud', phonePrefix: '+27', flag: '🇿🇦' },
    { code: 'AL', name: 'Albanie', phonePrefix: '+355', flag: '🇦🇱' },
    { code: 'DZ', name: 'Algérie', phonePrefix: '+213', flag: '🇩🇿' },
    { code: 'DE', name: 'Allemagne', phonePrefix: '+49', flag: '🇩🇪' },
    { code: 'AD', name: 'Andorre', phonePrefix: '+376', flag: '🇦🇩' },
    { code: 'AO', name: 'Angola', phonePrefix: '+244', flag: '🇦🇴' },
    { code: 'AG', name: 'Antigua-et-Barbuda', phonePrefix: '+1268', flag: '🇦🇬' },
    { code: 'SA', name: 'Arabie saoudite', phonePrefix: '+966', flag: '🇸🇦' },
    { code: 'AR', name: 'Argentine', phonePrefix: '+54', flag: '🇦🇷' },
    { code: 'AM', name: 'Arménie', phonePrefix: '+374', flag: '🇦🇲' },
    { code: 'AU', name: 'Australie', phonePrefix: '+61', flag: '🇦🇺' },
    { code: 'AT', name: 'Autriche', phonePrefix: '+43', flag: '🇦🇹' },
    { code: 'AZ', name: 'Azerbaïdjan', phonePrefix: '+994', flag: '🇦🇿' },
    { code: 'BS', name: 'Bahamas', phonePrefix: '+1242', flag: '🇧🇸' },
    { code: 'BH', name: 'Bahreïn', phonePrefix: '+973', flag: '🇧🇭' },
    { code: 'BD', name: 'Bangladesh', phonePrefix: '+880', flag: '🇧🇩' },
    { code: 'BB', name: 'Barbade', phonePrefix: '+1246', flag: '🇧🇧' },
    { code: 'BE', name: 'Belgique', phonePrefix: '+32', flag: '🇧🇪' },
    { code: 'BZ', name: 'Belize', phonePrefix: '+501', flag: '🇧🇿' },
    { code: 'BJ', name: 'Bénin', phonePrefix: '+229', flag: '🇧🇯' },
    { code: 'BT', name: 'Bhoutan', phonePrefix: '+975', flag: '🇧🇹' },
    { code: 'BY', name: 'Biélorussie', phonePrefix: '+375', flag: '🇧🇾' },
    { code: 'BO', name: 'Bolivie', phonePrefix: '+591', flag: '🇧🇴' },
    { code: 'BA', name: 'Bosnie-Herzégovine', phonePrefix: '+387', flag: '🇧🇦' },
    { code: 'BW', name: 'Botswana', phonePrefix: '+267', flag: '🇧🇼' },
    { code: 'BR', name: 'Brésil', phonePrefix: '+55', flag: '🇧🇷' },
    { code: 'BN', name: 'Brunei', phonePrefix: '+673', flag: '🇧🇳' },
    { code: 'BG', name: 'Bulgarie', phonePrefix: '+359', flag: '🇧🇬' },
    { code: 'BF', name: 'Burkina Faso', phonePrefix: '+226', flag: '🇧🇫' },
    { code: 'BI', name: 'Burundi', phonePrefix: '+257', flag: '🇧🇮' },
    { code: 'KH', name: 'Cambodge', phonePrefix: '+855', flag: '🇰🇭' },
    { code: 'CM', name: 'Cameroun', phonePrefix: '+237', flag: '🇨🇲' },
    { code: 'CA', name: 'Canada', phonePrefix: '+1', flag: '🇨🇦' },
    { code: 'CV', name: 'Cap-Vert', phonePrefix: '+238', flag: '🇨🇻' },
    { code: 'CF', name: 'Centrafrique', phonePrefix: '+236', flag: '🇨🇫' },
    { code: 'CL', name: 'Chili', phonePrefix: '+56', flag: '🇨🇱' },
    { code: 'CN', name: 'Chine', phonePrefix: '+86', flag: '🇨🇳' },
    { code: 'CY', name: 'Chypre', phonePrefix: '+357', flag: '🇨🇾' },
    { code: 'CO', name: 'Colombie', phonePrefix: '+57', flag: '🇨🇴' },
    { code: 'KM', name: 'Comores', phonePrefix: '+269', flag: '🇰🇲' },
    { code: 'CG', name: 'Congo', phonePrefix: '+242', flag: '🇨🇬' },
    { code: 'CD', name: 'Congo (RDC)', phonePrefix: '+243', flag: '🇨🇩' },
    { code: 'KR', name: 'Corée du Sud', phonePrefix: '+82', flag: '🇰🇷' },
    { code: 'KP', name: 'Corée du Nord', phonePrefix: '+850', flag: '🇰🇵' },
    { code: 'CR', name: 'Costa Rica', phonePrefix: '+506', flag: '🇨🇷' },
    { code: 'CI', name: 'Côte d\'Ivoire', phonePrefix: '+225', flag: '🇨🇮' },
    { code: 'HR', name: 'Croatie', phonePrefix: '+385', flag: '🇭🇷' },
    { code: 'CU', name: 'Cuba', phonePrefix: '+53', flag: '🇨🇺' },
    { code: 'DK', name: 'Danemark', phonePrefix: '+45', flag: '🇩🇰' },
    { code: 'DJ', name: 'Djibouti', phonePrefix: '+253', flag: '🇩🇯' },
    { code: 'DM', name: 'Dominique', phonePrefix: '+1767', flag: '🇩🇲' },
    { code: 'EG', name: 'Égypte', phonePrefix: '+20', flag: '🇪🇬' },
    { code: 'AE', name: 'Émirats arabes unis', phonePrefix: '+971', flag: '🇦🇪' },
    { code: 'EC', name: 'Équateur', phonePrefix: '+593', flag: '🇪🇨' },
    { code: 'ER', name: 'Érythrée', phonePrefix: '+291', flag: '🇪🇷' },
    { code: 'ES', name: 'Espagne', phonePrefix: '+34', flag: '🇪🇸' },
    { code: 'EE', name: 'Estonie', phonePrefix: '+372', flag: '🇪🇪' },
    { code: 'US', name: 'États-Unis', phonePrefix: '+1', flag: '🇺🇸' },
    { code: 'ET', name: 'Éthiopie', phonePrefix: '+251', flag: '🇪🇹' },
    { code: 'FJ', name: 'Fidji', phonePrefix: '+679', flag: '🇫🇯' },
    { code: 'FI', name: 'Finlande', phonePrefix: '+358', flag: '🇫🇮' },
    { code: 'FR', name: 'France', phonePrefix: '+33', flag: '🇫🇷' },
    { code: 'GA', name: 'Gabon', phonePrefix: '+241', flag: '🇬🇦' },
    { code: 'GM', name: 'Gambie', phonePrefix: '+220', flag: '🇬🇲' },
    { code: 'GE', name: 'Géorgie', phonePrefix: '+995', flag: '🇬🇪' },
    { code: 'GH', name: 'Ghana', phonePrefix: '+233', flag: '🇬🇭' },
    { code: 'GR', name: 'Grèce', phonePrefix: '+30', flag: '🇬🇷' },
    { code: 'GD', name: 'Grenade', phonePrefix: '+1473', flag: '🇬🇩' },
    { code: 'GT', name: 'Guatemala', phonePrefix: '+502', flag: '🇬🇹' },
    { code: 'GN', name: 'Guinée', phonePrefix: '+224', flag: '🇬🇳' },
    { code: 'GW', name: 'Guinée-Bissau', phonePrefix: '+245', flag: '🇬🇼' },
    { code: 'GQ', name: 'Guinée équatoriale', phonePrefix: '+240', flag: '🇬🇶' },
    { code: 'GY', name: 'Guyana', phonePrefix: '+592', flag: '🇬🇾' },
    { code: 'HT', name: 'Haïti', phonePrefix: '+509', flag: '🇭🇹' },
    { code: 'HN', name: 'Honduras', phonePrefix: '+504', flag: '🇭🇳' },
    { code: 'HU', name: 'Hongrie', phonePrefix: '+36', flag: '🇭🇺' },
    { code: 'IN', name: 'Inde', phonePrefix: '+91', flag: '🇮🇳' },
    { code: 'ID', name: 'Indonésie', phonePrefix: '+62', flag: '🇮🇩' },
    { code: 'IQ', name: 'Irak', phonePrefix: '+964', flag: '🇮🇶' },
    { code: 'IR', name: 'Iran', phonePrefix: '+98', flag: '🇮🇷' },
    { code: 'IE', name: 'Irlande', phonePrefix: '+353', flag: '🇮🇪' },
    { code: 'IS', name: 'Islande', phonePrefix: '+354', flag: '🇮🇸' },
    { code: 'IL', name: 'Israël', phonePrefix: '+972', flag: '🇮🇱' },
    { code: 'IT', name: 'Italie', phonePrefix: '+39', flag: '🇮🇹' },
    { code: 'JM', name: 'Jamaïque', phonePrefix: '+1876', flag: '🇯🇲' },
    { code: 'JP', name: 'Japon', phonePrefix: '+81', flag: '🇯🇵' },
    { code: 'JO', name: 'Jordanie', phonePrefix: '+962', flag: '🇯🇴' },
    { code: 'KZ', name: 'Kazakhstan', phonePrefix: '+7', flag: '🇰🇿' },
    { code: 'KE', name: 'Kenya', phonePrefix: '+254', flag: '🇰🇪' },
    { code: 'KG', name: 'Kirghizistan', phonePrefix: '+996', flag: '🇰🇬' },
    { code: 'KI', name: 'Kiribati', phonePrefix: '+686', flag: '🇰🇮' },
    { code: 'KW', name: 'Koweït', phonePrefix: '+965', flag: '🇰🇼' },
    { code: 'LA', name: 'Laos', phonePrefix: '+856', flag: '🇱🇦' },
    { code: 'LS', name: 'Lesotho', phonePrefix: '+266', flag: '🇱🇸' },
    { code: 'LV', name: 'Lettonie', phonePrefix: '+371', flag: '🇱🇻' },
    { code: 'LB', name: 'Liban', phonePrefix: '+961', flag: '🇱🇧' },
    { code: 'LR', name: 'Liberia', phonePrefix: '+231', flag: '🇱🇷' },
    { code: 'LY', name: 'Libye', phonePrefix: '+218', flag: '🇱🇾' },
    { code: 'LI', name: 'Liechtenstein', phonePrefix: '+423', flag: '🇱🇮' },
    { code: 'LT', name: 'Lituanie', phonePrefix: '+370', flag: '🇱🇹' },
    { code: 'LU', name: 'Luxembourg', phonePrefix: '+352', flag: '🇱🇺' },
    { code: 'MK', name: 'Macédoine du Nord', phonePrefix: '+389', flag: '🇲🇰' },
    { code: 'MG', name: 'Madagascar', phonePrefix: '+261', flag: '🇲🇬' },
    { code: 'MY', name: 'Malaisie', phonePrefix: '+60', flag: '🇲🇾' },
    { code: 'MW', name: 'Malawi', phonePrefix: '+265', flag: '🇲🇼' },
    { code: 'MV', name: 'Maldives', phonePrefix: '+960', flag: '🇲🇻' },
    { code: 'ML', name: 'Mali', phonePrefix: '+223', flag: '🇲🇱' },
    { code: 'MT', name: 'Malte', phonePrefix: '+356', flag: '🇲🇹' },
    { code: 'MA', name: 'Maroc', phonePrefix: '+212', flag: '🇲🇦' },
    { code: 'MU', name: 'Maurice', phonePrefix: '+230', flag: '🇲🇺' },
    { code: 'MR', name: 'Mauritanie', phonePrefix: '+222', flag: '🇲🇷' },
    { code: 'MX', name: 'Mexique', phonePrefix: '+52', flag: '🇲🇽' },
    { code: 'FM', name: 'Micronésie', phonePrefix: '+691', flag: '🇫🇲' },
    { code: 'MD', name: 'Moldavie', phonePrefix: '+373', flag: '🇲🇩' },
    { code: 'MC', name: 'Monaco', phonePrefix: '+377', flag: '🇲🇨' },
    { code: 'MN', name: 'Mongolie', phonePrefix: '+976', flag: '🇲🇳' },
    { code: 'ME', name: 'Monténégro', phonePrefix: '+382', flag: '🇲🇪' },
    { code: 'MZ', name: 'Mozambique', phonePrefix: '+258', flag: '🇲🇿' },
    { code: 'MM', name: 'Myanmar', phonePrefix: '+95', flag: '🇲🇲' },
    { code: 'NA', name: 'Namibie', phonePrefix: '+264', flag: '🇳🇦' },
    { code: 'NR', name: 'Nauru', phonePrefix: '+674', flag: '🇳🇷' },
    { code: 'NP', name: 'Népal', phonePrefix: '+977', flag: '🇳🇵' },
    { code: 'NI', name: 'Nicaragua', phonePrefix: '+505', flag: '🇳🇮' },
    { code: 'NE', name: 'Niger', phonePrefix: '+227', flag: '🇳🇪' },
    { code: 'NG', name: 'Nigeria', phonePrefix: '+234', flag: '🇳🇬' },
    { code: 'NO', name: 'Norvège', phonePrefix: '+47', flag: '🇳🇴' },
    { code: 'NZ', name: 'Nouvelle-Zélande', phonePrefix: '+64', flag: '🇳🇿' },
    { code: 'OM', name: 'Oman', phonePrefix: '+968', flag: '🇴🇲' },
    { code: 'UG', name: 'Ouganda', phonePrefix: '+256', flag: '🇺🇬' },
    { code: 'UZ', name: 'Ouzbékistan', phonePrefix: '+998', flag: '🇺🇿' },
    { code: 'PK', name: 'Pakistan', phonePrefix: '+92', flag: '🇵🇰' },
    { code: 'PW', name: 'Palaos', phonePrefix: '+680', flag: '🇵🇼' },
    { code: 'PS', name: 'Palestine', phonePrefix: '+970', flag: '🇵🇸' },
    { code: 'PA', name: 'Panama', phonePrefix: '+507', flag: '🇵🇦' },
    { code: 'PG', name: 'Papouasie-Nouvelle-Guinée', phonePrefix: '+675', flag: '🇵🇬' },
    { code: 'PY', name: 'Paraguay', phonePrefix: '+595', flag: '🇵🇾' },
    { code: 'NL', name: 'Pays-Bas', phonePrefix: '+31', flag: '🇳🇱' },
    { code: 'PE', name: 'Pérou', phonePrefix: '+51', flag: '🇵🇪' },
    { code: 'PH', name: 'Philippines', phonePrefix: '+63', flag: '🇵🇭' },
    { code: 'PL', name: 'Pologne', phonePrefix: '+48', flag: '🇵🇱' },
    { code: 'PT', name: 'Portugal', phonePrefix: '+351', flag: '🇵🇹' },
    { code: 'QA', name: 'Qatar', phonePrefix: '+974', flag: '🇶🇦' },
    { code: 'DO', name: 'République dominicaine', phonePrefix: '+1809', flag: '🇩🇴' },
    { code: 'CZ', name: 'République tchèque', phonePrefix: '+420', flag: '🇨🇿' },
    { code: 'RO', name: 'Roumanie', phonePrefix: '+40', flag: '🇷🇴' },
    { code: 'GB', name: 'Royaume-Uni', phonePrefix: '+44', flag: '🇬🇧' },
    { code: 'RU', name: 'Russie', phonePrefix: '+7', flag: '🇷🇺' },
    { code: 'RW', name: 'Rwanda', phonePrefix: '+250', flag: '🇷🇼' },
    { code: 'KN', name: 'Saint-Kitts-et-Nevis', phonePrefix: '+1869', flag: '🇰🇳' },
    { code: 'LC', name: 'Sainte-Lucie', phonePrefix: '+1758', flag: '🇱🇨' },
    { code: 'VC', name: 'Saint-Vincent-et-les-Grenadines', phonePrefix: '+1784', flag: '🇻🇨' },
    { code: 'SB', name: 'Salomon', phonePrefix: '+677', flag: '🇸🇧' },
    { code: 'SV', name: 'Salvador', phonePrefix: '+503', flag: '🇸🇻' },
    { code: 'WS', name: 'Samoa', phonePrefix: '+685', flag: '🇼🇸' },
    { code: 'SM', name: 'Saint-Marin', phonePrefix: '+378', flag: '🇸🇲' },
    { code: 'ST', name: 'Sao Tomé-et-Principe', phonePrefix: '+239', flag: '🇸🇹' },
    { code: 'SN', name: 'Sénégal', phonePrefix: '+221', flag: '🇸🇳' },
    { code: 'RS', name: 'Serbie', phonePrefix: '+381', flag: '🇷🇸' },
    { code: 'SC', name: 'Seychelles', phonePrefix: '+248', flag: '🇸🇨' },
    { code: 'SL', name: 'Sierra Leone', phonePrefix: '+232', flag: '🇸🇱' },
    { code: 'SG', name: 'Singapour', phonePrefix: '+65', flag: '🇸🇬' },
    { code: 'SK', name: 'Slovaquie', phonePrefix: '+421', flag: '🇸🇰' },
    { code: 'SI', name: 'Slovénie', phonePrefix: '+386', flag: '🇸🇮' },
    { code: 'SO', name: 'Somalie', phonePrefix: '+252', flag: '🇸🇴' },
    { code: 'SD', name: 'Soudan', phonePrefix: '+249', flag: '🇸🇩' },
    { code: 'SS', name: 'Soudan du Sud', phonePrefix: '+211', flag: '🇸🇸' },
    { code: 'LK', name: 'Sri Lanka', phonePrefix: '+94', flag: '🇱🇰' },
    { code: 'SE', name: 'Suède', phonePrefix: '+46', flag: '🇸🇪' },
    { code: 'CH', name: 'Suisse', phonePrefix: '+41', flag: '🇨🇭' },
    { code: 'SR', name: 'Suriname', phonePrefix: '+597', flag: '🇸🇷' },
    { code: 'SZ', name: 'Eswatini', phonePrefix: '+268', flag: '🇸🇿' },
    { code: 'SY', name: 'Syrie', phonePrefix: '+963', flag: '🇸🇾' },
    { code: 'TJ', name: 'Tadjikistan', phonePrefix: '+992', flag: '🇹🇯' },
    { code: 'TZ', name: 'Tanzanie', phonePrefix: '+255', flag: '🇹🇿' },
    { code: 'TD', name: 'Tchad', phonePrefix: '+235', flag: '🇹🇩' },
    { code: 'TH', name: 'Thaïlande', phonePrefix: '+66', flag: '🇹🇭' },
    { code: 'TL', name: 'Timor oriental', phonePrefix: '+670', flag: '🇹🇱' },
    { code: 'TG', name: 'Togo', phonePrefix: '+228', flag: '🇹🇬' },
    { code: 'TO', name: 'Tonga', phonePrefix: '+676', flag: '🇹🇴' },
    { code: 'TT', name: 'Trinité-et-Tobago', phonePrefix: '+1868', flag: '🇹🇹' },
    { code: 'TN', name: 'Tunisie', phonePrefix: '+216', flag: '🇹🇳' },
    { code: 'TM', name: 'Turkménistan', phonePrefix: '+993', flag: '🇹🇲' },
    { code: 'TR', name: 'Turquie', phonePrefix: '+90', flag: '🇹🇷' },
    { code: 'TV', name: 'Tuvalu', phonePrefix: '+688', flag: '🇹🇻' },
    { code: 'UA', name: 'Ukraine', phonePrefix: '+380', flag: '🇺🇦' },
    { code: 'UY', name: 'Uruguay', phonePrefix: '+598', flag: '🇺🇾' },
    { code: 'VU', name: 'Vanuatu', phonePrefix: '+678', flag: '🇻🇺' },
    { code: 'VA', name: 'Vatican', phonePrefix: '+379', flag: '🇻🇦' },
    { code: 'VE', name: 'Venezuela', phonePrefix: '+58', flag: '🇻🇪' },
    { code: 'VN', name: 'Vietnam', phonePrefix: '+84', flag: '🇻🇳' },
    { code: 'YE', name: 'Yémen', phonePrefix: '+967', flag: '🇾🇪' },
    { code: 'ZM', name: 'Zambie', phonePrefix: '+260', flag: '🇿🇲' },
    { code: 'ZW', name: 'Zimbabwe', phonePrefix: '+263', flag: '🇿🇼' },
];

// Common European countries (for quick access)
export const europeanCountries = [
    'BE', 'FR', 'NL', 'DE', 'LU', 'GB', 'ES', 'IT', 'PT', 'CH', 'AT',
    'IE', 'DK', 'SE', 'NO', 'FI', 'PL', 'CZ', 'HU', 'RO', 'GR'
];

/**
 * Get country by code
 * @param {string} code - Country code (e.g., 'BE', 'FR')
 * @returns {Object|undefined} Country object or undefined
 */
export const getCountryByCode = (code) => {
    return countries.find(c => c.code === code);
};

/**
 * Get phone prefix by country code
 * @param {string} code - Country code
 * @returns {string} Phone prefix (e.g., '+32')
 */
export const getPhonePrefix = (code) => {
    const country = getCountryByCode(code);
    return country?.phonePrefix || '+32';
};

/**
 * Get country name by code
 * @param {string} code - Country code
 * @returns {string} Country name in French
 */
export const getCountryName = (code) => {
    const country = getCountryByCode(code);
    return country?.name || code;
};

/**
 * Search countries by name or code
 * @param {string} query - Search query
 * @returns {Array} Matching countries
 */
export const searchCountries = (query) => {
    if (!query) return countries;
    const lowerQuery = query.toLowerCase();
    return countries.filter(c =>
        c.name.toLowerCase().includes(lowerQuery) ||
        c.code.toLowerCase().includes(lowerQuery) ||
        c.phonePrefix.includes(query)
    );
};

/**
 * Get European countries first, then the rest
 * @returns {Array} Sorted countries with European countries first
 */
export const getCountriesEuropeFirst = () => {
    const european = countries.filter(c => europeanCountries.includes(c.code));
    const others = countries.filter(c => !europeanCountries.includes(c.code));
    return [...european, ...others];
};

export default countries;
